// Modal basato su Radix Dialog — accessibile
import * as Dialog from '@radix-ui/react-dialog'
import { X } from 'lucide-react'
import { cn } from '../../lib/utils'

interface ModalProps {
  open: boolean
  onClose: () => void
  title?: string
  description?: string
  children: React.ReactNode
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full'
}

const SIZE_CLASSES = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  full: 'max-w-3xl',
}

export function Modal({ open, onClose, title, description, children, className, size = 'md' }: ModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={(o) => !o && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <Dialog.Content
          className={cn(
            'fixed left-1/2 top-1/2 z-50 w-full -translate-x-1/2 -translate-y-1/2',
            'flex max-h-[90vh] flex-col',
            'rounded-xl border border-[var(--fc-border)] bg-[var(--fc-surface)] shadow-[var(--fc-shadow-lg)]',
            'data-[state=open]:animate-in data-[state=closed]:animate-out',
            'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
            'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
            'data-[state=closed]:slide-out-to-left-1/2 data-[state=open]:slide-in-from-left-1/2',
            SIZE_CLASSES[size],
            className
          )}
        >
          <div className="flex items-center justify-between px-6 pt-6 pb-4 shrink-0">
            {title && (
              <Dialog.Title className="text-lg font-semibold text-[var(--fc-foreground)]">
                {title}
              </Dialog.Title>
            )}
            <Dialog.Close
              className="ml-auto rounded p-1 opacity-70 hover:opacity-100 transition-opacity focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--fc-border-focus)]"
              aria-label="Chiudi"
            >
              <X className="h-5 w-5" />
            </Dialog.Close>
          </div>
          {description && (
            <Dialog.Description className="px-6 pb-4 text-sm text-[var(--fc-foreground-muted)] shrink-0">
              {description}
            </Dialog.Description>
          )}
          <div className="flex-1 overflow-y-auto px-6 pb-6">
            {children}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
